// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bDyq","type":"styles_type__2WJkx","choices":"styles_choices__2JO7G"};